@if(readonly && value) {
  <div class="input-container" [style.width]="width">
    <div class="header">
      <div class="label-readonly">{{label}}</div>
    </div>

    <input
      type="text"
      class="input-readonly"
      [disabled] = true
      [(ngModel)]="value"
      [placeholder]="placeholder"
    >
  </div>

} @else {
  <div class="input-container" [style.width]="width">
    <div class="header hide-empty">
      @if(label) {
        <div class="label">{{label}}</div>
      }

      @if(link && text) {
        <div><app-link [link]="link" [text]="text"></app-link></div>
      } @else if (switchBtnText) {
        <app-form-switch-button
          [text]="switchBtnText"
          (switchForm)="onClickBtn()"
        ></app-form-switch-button>
      }
    </div>

    <div
      class="input-wrapper"
      [class]="{'error': validationError || displayValidationError, 'check': checkedState, 'warn': warningState}"
    >
      <input
        type="text"
        class="input"
        [attr.data-id]="controlId + 'input-field-'+ label"
        [disabled]="isDisabled || disabled"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        (keydown)="onKeyPressed($event)"
        (focus)="focused.emit()"
        (blur)="blured.emit(); onTouched()"
      >

      <app-tooltip [customContent]="true">
        <i
          container="body"
          class="input-icon icon"
          placement="top"
          [ngbTooltip]="warningTooltipMessage"
          [tooltipClass]="'tooltip-info width-auto'"
          [class]="{'ic-info-circle-16': validationError || warningState || displayValidationError, 'ic-checkmark-circle-16': checkedState}">
        </i>
      </app-tooltip>
    </div>

    @if(helperText) {
      <div class="helper" [class]="{'error': validationError}">{{helperText}}</div>
    }

    @if(shouldShowErrors && displayValidationError) {
      <app-validation-error [customErrors]="customErrors"></app-validation-error>
    }
  </div>
}

